module.exports = __webpack_public_path__ + "img/thumbsup.f606e858.png";